export default __webpack_public_path__ + "media/images/card-join-comittee.jpg";